import { clsx } from 'clsx';

interface ProgressBarProps {
  value: number;
  max: number;
  size?: 'sm' | 'md';
  showLabel?: boolean;
  className?: string;
}

export function ProgressBar({ value, max, size = 'md', showLabel = false, className }: ProgressBarProps) {
  const pct = max > 0 ? Math.min((value / max) * 100, 100) : 0;
  const color = pct >= 90 ? 'bg-red-500' : pct >= 70 ? 'bg-amber-500' : 'bg-nexus-500';

  return (
    <div className={className}>
      <div
        className={clsx('w-full bg-surface-700 rounded-full overflow-hidden', {
          'h-1.5': size === 'sm',
          'h-2.5': size === 'md',
        })}
      >
        <div
          className={clsx('h-full rounded-full transition-all duration-500', color)}
          style={{ width: `${pct}%` }}
        />
      </div>
      {showLabel && (
        <p className="mt-1 text-xs text-surface-400">
          {value.toLocaleString()} / {max.toLocaleString()} ({pct.toFixed(1)}%)
        </p>
      )}
    </div>
  );
}
